import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

declare var window: any;

@Injectable()
export class BreadcrumbService {
  private url = 'breadcrumbs';

  constructor(private httpClient: HttpClientService) {}

  create(breadcrumb: any): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, { breadcrumb: breadcrumb });
  }

  index(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`);
  }
}
